const sanitizeGender = s => {
  if (s && s !== 'All genders') {
    return s.toLowerCase();
  }
  return undefined;
};

const sanitizeNew = s => {
  switch (s) {
    case 'Only new products':
      return 1;
    case 'Only products that aren’t new':
      return 0;
    default:
      return undefined;
  }
};

export default (filterValue, fieldName) => {
  switch (fieldName) {
    case 'gender':
      return sanitizeGender(filterValue);
    case 'new':
      return sanitizeNew(filterValue);
    default:
      return filterValue || undefined;
  }
};
